import React from 'react';
import styled from '../../components/styled';

import { RollupDetails } from '../../services/dataModels';

interface RollupDetailsCardProps {
  rollupDetails: RollupDetails;
  style?: any;
}

const RollupDetailsCard = ({ rollupDetails, style }: RollupDetailsCardProps) => {
  return (
    <Container style={style}>
      {[
        { label: 'Asset', value: rollupDetails?.Asset ?? 'N/A' },
        { label: 'Created Time', value: rollupDetails?.CreatedTime ?? 'N/A' },
        { label: 'Author', value: rollupDetails?.Author ?? 'N/A' },
      ].map((item, index) => (
        <RollupItem key={index}>
          <RollupLabel>{item.label}</RollupLabel>
          <RollupValue>{item.value}</RollupValue>
        </RollupItem>
      ))}
    </Container>
  );
};

export default RollupDetailsCard;

const Container = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  padding-horizontal: 3px;
`;

const RollupItem = styled.View`
  padding: 10px;
`;

const RollupLabel = styled.Text`
  opacity: 0.5;
  font-size: 10px;
`;

const RollupValue = styled.Text`
  font-size: 14px;
`;
